import { render, staticRenderFns } from "./history-list.vue?vue&type=template&id=001a529f&"
import script from "./history-list.vue?vue&type=script&lang=js&"
export * from "./history-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports